/* eslint-disable no-confusing-arrow */
import rbacRules from '../rbacRules';

export const checkPermission = (userPermissions, permission) =>
  userPermissions?.includes(permission);

/**
 * @description Verifica se usuário possui permissão para algo
 * @param {rbacRules} rules
 * @param {SOTRAN|CLIENTE} profile
 * @param {Array<String>} roles
 * @param {Array<String>|String} action
 * @param {Object<Any>} data
 */
const check = (rules, profile, userPermissions, action, data) => {
  if (!profile) return true;

  if (typeof action !== 'string' && !Array.isArray(action)) return false;

  const ruleProfile = rules[profile];
  if (!ruleProfile) {
    return false; // profile is not present in the rules
  }

  let hasAccess = false;
  if (
    userPermissions &&
    (userPermissions.includes(action) ||
      userPermissions.some(value => action.includes(value)))
  ) {
    // static rule provided for action
    hasAccess = true;
  }

  // é possível definir permissões dinâmicas, do tipo: "só deixar editar o registro quem o criou"
  // possível apenas para strings básicas
  // exemplo disponível em: https://github.com/itaditya/react-rbac-auth0-article-code/blob/master/src/constants/rbac-rules.js#L30
  const dynamicPermissions = ruleProfile.dynamic;
  if (dynamicPermissions && typeof action === 'string') {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return hasAccess;
    }
    return data ? permissionCondition(data) : false;
  }
  return hasAccess;
};

const Can = props =>
  check(rbacRules, props.profile, props.permissions, props.perform, props.data)
    ? props.yes()
    : props.no();

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
